// จังหวัดที่มีสาขา กับ id ของรูปจังหวัด/หมุด/ป้ายชื่อใน public/images/map.svg
// (id มาจากไฟล์ที่ export จาก Adobe XD จึงไม่สื่อความหมาย ต้องเทียบตำแหน่งเอา)
// bounds = ขอบเขตละติจูด/ลองจิจูดโดยประมาณของจังหวัด ใช้แปลงพิกัดสาขาเป็นตำแหน่งบนรูปจังหวัด
// zoomWidth = ความกว้าง viewBox ตอนซูม (กรุงเทพฯ จังหวัดเล็ก ต้องกำหนดเองให้เห็นทั้งจังหวัดพร้อมรอบข้าง)
export const BRANCH_REGIONS = [
    {
        key: 'chiangmai', label: 'เชียงใหม่', match: /เชียงใหม่/,
        province: 'Path_320', marker: 'Group_1118', text: 'CHIANGMAI',
        bounds: { minLat: 17.24, maxLat: 20.13, minLng: 98.07, maxLng: 99.57 }
    },
    {
        key: 'phitsanulok', label: 'พิษณุโลก', match: /พิษณุโลก/,
        province: 'Path_345', marker: 'Group_1119', text: 'PHITSANULOK',
        bounds: { minLat: 16.32, maxLat: 17.73, minLng: 99.85, maxLng: 101.07 }
    },
    {
        key: 'bangkok', label: 'กรุงเทพมหานคร', match: /กรุงเทพ/,
        province: 'Path_342', marker: 'Group_1120', text: 'BANGKOK',
        bounds: { minLat: 13.49, maxLat: 13.96, minLng: 100.33, maxLng: 100.94 },
        zoomWidth: 60
    },
    {
        key: 'suratthani', label: 'สุราษฎร์ธานี', match: /สุราษ/,
        province: 'Path_308', marker: 'Group_1123', text: 'SURAT_THANI',
        bounds: { minLat: 8.30, maxLat: 9.80, minLng: 98.50, maxLng: 99.96 }
    }
];

// หาจังหวัดบนแผนที่จากที่อยู่ (ข้อมูลสาขาจาก API ไม่มีฟิลด์จังหวัดแยก)
export function regionOf(address) {
    const region = BRANCH_REGIONS.find(r => r.match.test(address || ''));
    return region ? region.key : null;
}
